import axios from 'axios';
import { WEBHOOK_CONSUMER_API_BASE_URL } from '../config';
import { attachAuthInterceptor } from '../utils/attachAuthInterceptor';

const client = axios.create({
  baseURL: WEBHOOK_CONSUMER_API_BASE_URL,
  withCredentials: true,
});
attachAuthInterceptor(client);

export const listWebhookEndpoints = (headers) =>
  client.get('/api/v1/webhooks/endpoints', { headers });

export const createWebhookEndpoint = (payload, headers) =>
  client.post('/api/v1/webhooks/endpoints', payload, { headers });

export const updateWebhookEndpoint = (id, payload, headers) =>
  client.put(`/api/v1/webhooks/endpoints/${id}`, payload, { headers });

export const regenerateWebhookEndpointKey = (id, headers) =>
  client.post(`/api/v1/webhooks/endpoints/${id}/regenerate`, {}, { headers });

export const deleteWebhookEndpoint = (id, headers) =>
  client.delete(`/api/v1/webhooks/endpoints/${id}`, { headers });

export const getWebhookMapping = (id, headers) =>
  client.get(`/api/v1/webhooks/endpoints/${id}/mapping`, { headers });

export const saveWebhookMapping = (id, payload, headers) =>
  client.post(`/api/v1/webhooks/endpoints/${id}/mapping`, payload, { headers });

export const getWebhookWorkflow = (id, headers) =>
  client.get(`/api/v1/webhooks/endpoints/${id}/workflow`, { headers });

export const saveWebhookWorkflow = (id, payload, headers) =>
  client.post(`/api/v1/webhooks/endpoints/${id}/workflow`, payload, { headers });

export const listWebhookEvents = (id, headers, params = {}) =>
  client.get(`/api/v1/webhooks/endpoints/${id}/events`, { headers, params });

export const listWebhookRuns = (id, headers) =>
  client.get(`/api/v1/webhooks/endpoints/${id}/runs`, { headers });

export const listWebhookSubscriptions = (id, headers) =>
  client.get(`/api/v1/webhooks/endpoints/${id}/subscriptions`, { headers });

export const saveWebhookSubscription = (id, payload, headers) =>
  client.post(`/api/v1/webhooks/endpoints/${id}/subscriptions`, payload, { headers });

export const updateWebhookSubscription = (id, payload, headers) =>
  client.put(`/api/v1/webhooks/subscriptions/${id}`, payload, { headers });

export const deleteWebhookSubscription = (id, headers) =>
  client.delete(`/api/v1/webhooks/subscriptions/${id}`, { headers });

export const listWebhookDeliveries = (headers, params = {}) =>
  client.get('/api/v1/webhooks/deliveries', { headers, params });

export const publishWebhookEventAuth = (payload, headers) =>
  client.post('/api/v1/webhooks/events/publish-auth', payload, { headers });
